import React from "react";
import FlatCard from "../../../../atoms/FlatCard";

interface DoctorReportCardProps {
  title: string;
  children: React.ReactNode;
  editMode?: boolean;
}

export default function DoctorReportCard({ title, editMode, children }: DoctorReportCardProps) {
  return (
    <FlatCard
      title={title}
      sx={{
        flex: 1,
        opacity: editMode ? 1 : 0.8,
        pointerEvents: editMode ? "auto" : "none",
      }}
      sxContent={{ padding: "8px" }}
    >
      {children}
    </FlatCard>
  );
}
